import { enableProdMode } from "@angular/core";
import { environment } from "src/environments/environment";

import { bootstrapApplication } from "@angular/platform-browser";
import { IFrameModulesAppComponent } from "./app/iframe-modules-app.component";
import { iframeModulesAppConfig } from "./app/iframe-modules-app.config";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(IFrameModulesAppComponent, iframeModulesAppConfig).catch(err => console.error(err));
